export enum FilterType {
  Numeric = 'NUMERIC',
  Date = 'DATE',
  Text = 'TEXT',
  None = 'NONE'
}

export enum FilterSubType {
  Single = 'SINGLE',
  Range = 'RANGE',
  None = 'NONE'
}
